import UntitledUIRenderer, { UntitledUIRendererProps } from './UntitledUIRenderer';

export type WithUntitledUIRendererParams = UntitledUIRendererProps;

export const withUntitledUIRenderer = (params: WithUntitledUIRendererParams) => {

  return () => UntitledUIRenderer(params);
};
